import axiosInstance from 'api/axiosInstance'
import { type ReportPost, type ReportType, type ReportUserOrMessage } from 'types/api/report'

export const getReportTypes = async (type: string): Promise<ReportType[]> => {
    const { data } = await axiosInstance({
        method: 'GET',
        url: `/api/report/types?type=${type}`
    })

    return data?.data
}

export const reportPost = async ({
    postId,
    message,
    reportType
}: ReportPost) => {
    const { data } = await axiosInstance({
        method: 'POST',
        url: `/api/report/post/${postId}`,
        data: {
            message,
            report_type_id: reportType
        }
    })

    return data
}

export const restrictUser = async (userId: string) => {
    const { data } = await axiosInstance({
        method: 'POST',
        url: 'api/user/restrict',
        data: {
            user_id: userId
        }
    })

    return data
}

export const blockUser = async (userId: string) => {
    const { data } = await axiosInstance({
        method: 'POST',
        url: '/api/user/block',
        data: {
            user_id: userId
        }
    })

    return data
}

export const reportUser = async ({ id, reportData }: ReportUserOrMessage) => {
    const { data } = await axiosInstance({
        method: 'POST',
        url: `/api/report/user/${id}`,
        data: reportData
    })

    return data
}

export const reportMessage = async ({
    id,
    reportData
}: ReportUserOrMessage) => {
    const { data } = await axiosInstance({
        method: 'POST',
        url: `/api/report/message/${id}`,
        data: reportData
    })

    return data
}
